import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Pedidos',
  buttons: {
    actions: 'Ações',
    [action_create_dummy_order]: 'Criar pedido de teste',
    [action_launch_orders_portal_app]: 'Abrir portal de pedidos',
    show_order_details: 'Ver detalhes do pedido',
    track_order: 'Rastrear pedido',
    update_dropoff_time: 'Atualizar hora de entrega',
    download_receipt: 'Descarregar recibo',
    open_payment_page: 'Abrir página de pagamento',
  },
  form: {
    customer_details: {
      placeholder: 'Introduza o nome ou telefone do cliente',
    },
    amount_min: {
      placeholder: 'Valor mínimo',
    },
    amount_max: {
      placeholder: 'Valor máximo',
    },
    utm_source: {
      placeholder: 'Introduza utm source',
    },
    utm_medium: {
      placeholder: 'Introduza utm medium',
    },
    utm_campaign: {
      placeholder: 'Introduza utm campaign',
    },
    utm_advertisement_id: {
      placeholder: 'Introduza utm advertisement id',
    },
  },
  labels: {
    // A table order's table under its method: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Mesa {{name}}',
    no_orders: 'Ainda sem pedidos',
    total_orders: 'Total de pedidos',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Recolha',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.on_site]: 'Pedidos à mesa',
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'Pendente',
    [ORDER_PAYMENT_STATUSES.paid]: 'Pago',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Parcialmente reembolsado',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Reembolsado',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Aguarda aprovação',
      [FULFILLMENT_STATUSES.reviewed]: 'Aguarda aprovação',
      [FULFILLMENT_STATUSES.accepted]: 'Em processamento',
      [FULFILLMENT_STATUSES.preparing]: 'Em processamento',
      [FULFILLMENT_STATUSES.ready]: 'Em processamento',
      [FULFILLMENT_STATUSES.on_delivery]: 'Em processamento',
      [FULFILLMENT_STATUSES.picked]: 'Concluído',
      [FULFILLMENT_STATUSES.rejected]: 'Rejeitado',
      null: 'Desconhecido',
      undefined: 'Desconhecido',
    },
  },
  tags: {
    dummy: 'TESTE',
    pickup: 'Recolha',
    internal_delivery: 'Entrega interna',
    external_delivery: 'Entrega externa',
    on_site: 'Pedidos à mesa',
    scheduled: 'Agendado',
    reward: 'Recompensa',
    mobile: 'Móvel',
    invoice: 'Fatura',
    cash: 'Dinheiro',
    rejected_automatically: 'Rejeitado automaticamente',
    rejected_manually: 'Rejeitado manualmente',
    call_center: 'Call center',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    tags: 'Etiquetas',
    order_placed: 'Pedido efetuado',
    ready_at: 'Pedido pronto',
    customer: 'Cliente',
    items: 'Itens',
    method: 'Método',
    payment_status: 'Estado do pagamento',
    fulfillment_status: 'Estado',
    total: 'Total',
    utm_source: 'Fonte UTM',
    utm_medium: 'Meio UTM',
    utm_campaign: 'Campanha UTM',
    utm_advertisement_id: 'Id de Anúncio UTM',
  },
  metrics: {
    total_orders: 'Total de pedidos',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_create_dummy_order: 'Falha ao criar pedido de teste',
    dummy_order_created: 'Pedido de teste criado',
    failed_to_launch_orders_portal_app: 'Falha ao abrir o portal de pedidos',
    failed_to_download_receipt: 'Falha ao descarregar recibo',
  },
};
